// frontend-base site: hosts the apps that have moved to frontend-base in
// Verawood (instructor dashboard, notifications). Login, learner dashboard,
// courseware, etc. are still served by the classic MFEs next to it.
//
// The double-underscore placeholders below are filled from build args in
// build/mfe/Dockerfile.
import { EnvironmentTypes, SiteConfig, footerApp, headerApp, shellApp } from '@openedx/frontend-base';
import { instructorDashboardApp } from '@openedx/frontend-app-instructor-dashboard';
import { notificationsApp } from '@openedx/frontend-app-notifications';
import customApp from './src/customApp';
import { addApp } from './src/utils';

import '@openedx/frontend-base/shell/style';
// The ThervuMitra theme (Paragon build plus brand layer, served by Caddy at
// /theme/, as for the classic MFEs) is loaded at runtime: Paragon through
// `theme` below, the brand layer from public/index.html after it.

const siteConfig: SiteConfig = {
  siteId: 'thervumitra-site',
  siteName: 'ThervuMitra',
  baseUrl: 'https://apps.thervumitra.com',
  cmsBaseUrl: 'https://studio.thervumitra.com',
  lmsBaseUrl: 'https://learn.thervumitra.com',
  loginUrl: 'https://learn.thervumitra.com/login',
  logoutUrl: 'https://learn.thervumitra.com/logout',

  headerLogoImageUrl: 'https://apps.thervumitra.com/theme/images/logo.svg',
  theme: {
    core: { url: 'https://apps.thervumitra.com/theme/paragon/core.min.css' },
    defaults: { light: 'light' },
    variants: { light: { url: 'https://apps.thervumitra.com/theme/paragon/light.min.css' } },
  },

  environment: EnvironmentTypes.PRODUCTION,
  apps: [
    shellApp,
    headerApp,
    footerApp,
    customApp,
  ],
  // The logo goes to the main site (thervumitra.com).
  externalRoutes: [{ role: 'org.openedx.frontend.role.home', url: 'https://thervumitra.com/' }],

  // Served by the LMS through Caddy on the MFE host (same origin).
  runtimeConfigJsonUrl: '/api/frontend_site_config/v1/',
  accessTokenCookieName: 'edx-jwt-cookie-header-payload',
};

addApp(siteConfig, instructorDashboardApp);
addApp(siteConfig, notificationsApp);

export default siteConfig;
